<p-toast></p-toast>
<p-confirmDialog rejectButtonStyleClass="p-button-outlined"></p-confirmDialog>
<div class="courseDetailsScreen" *ngIf="(isCourseFound && isPageFound); else courseNotFound">
    <app-top-bar [topBarTitle]="topBarTitle"></app-top-bar>
  <div class="courseDetailsContainer" *ngIf="courseDetail!!">
    <div class="columns toolbar">
      <div class="column1">
        <div class="overflow-ellipsis" tooltipPosition="bottom" pTooltip="{{ courseDetail.courseNumber }} {{ courseDetail.name }}" tooltipStyleClass="tooltip">
            <app-label class="courseNumber" labelText="{{ courseDetail.courseNumber }} "></app-label>
            <app-label class="courseName" labelText="{{courseDetail.name}}"></app-label>
        </div>
      </div>
        <div class="btn column2" *ngIf="courseDetail.courseAuthorizationFlags.isEditButtonAvailable">
            <p-button
              appPreventDoubleClick
              styleClass="p-button-outlined"
              icon="fa fa-pen"
              id="editCourseButton"
              class="edit-course-button"
              pTooltip="Edit Course Properties"
              tooltipPosition="left"
              iconPos="right"
              (debounceClick)="editCourse()"
            ></p-button>
      </div>
      <div class="btn column2" *ngIf="courseDetail.courseAuthorizationFlags.isQuizButtonAvailable"> 
        <p-button
        appPreventDoubleClick
          styleClass="p-button-outlined"
          icon="fa-solid fa-clipboard-question"
          id="courseProficienctQuizButton"
          pTooltip="Proficiency Quiz"
          tooltipPosition="left"
          iconPos="left"
          (debounceClick)="openCourseProficiencyQuizSlider()"
        ></p-button>
      </div>
      <div class="btn column2" *ngIf="courseDetail.courseAuthorizationFlags.isTrainingItemGroupManagementButtonAvailable"> 
       <p-button
         appPreventDoubleClick
         styleClass="p-button-outlined"
         icon="fas fa-building-columns"
         id="trainingItemGroupManagementButton"
         pTooltip="Training Item Group Management"
         tooltipPosition="left"
         iconPos="left"
         (debounceClick)="openTrainingItemGroupManagementSlider()"
       ></p-button>
     </div> 
      <div class="btn column2" *ngIf="courseDetail.courseAuthorizationFlags.isCreateTrainingRequirementButtonAvailable"> 
        <p-button
        appPreventDoubleClick
          styleClass="p-button-outlined"
          icon="fa-solid fa-users"
          id="createTrainingRequirementButton"
          pTooltip="Create Training Requirement"
          tooltipPosition="left"
          iconPos="left"
          (debounceClick)="openCreateTrainingRequirementSlider()"
        ></p-button>
      </div> 
    </div>
    
    <div class="bpt-main-content-container" style="overflow-y: auto;">
        <p-tabView (onChange)="onTabChange($event)">
          <p-tabPanel header="{{ courseInfoTitle }}">
            <p-fieldset legend="{{courseSummaryTitle}}" [toggleable]="true">
                <div class="grid">
                    <div class="col">
                        <app-label labelText="Status"></app-label>
                        <div class="grid pt-1 course-status">
                            <div class="col max-w-0 pb-0">
                            <em
                            class="pi pi-circle-fill ml-1 mr-1 mt-1"
                            [ngClass]="calculateStatusColor(courseDetail.status)"></em>
                        </div>
                        <div class="col ml-2 pb-0">
                        <app-read-only readonlyText="{{ courseDetail.status }}"></app-read-only>
                        </div>
                        </div>
                    </div>
                    <div class="col">
                        <app-label labelText="Legacy Course #"></app-label>
                        <app-read-only readonlyText="{{ courseDetail.legacyCourseNumber}}"></app-read-only>
                    </div>
                    <div class="col">
                        <app-label labelText="Format"></app-label>
                        <app-read-only readonlyText="{{ courseDetail.format }}"></app-read-only>
                    </div>
                    <div class="col">
                        <app-label labelText="Type"></app-label>
                        <app-read-only readonlyText="{{ courseDetail.type }}"></app-read-only>
                    </div>
                </div>
                <div class="grid">
                    <div class="col-9 text-justify pr-5">
                        <app-label labelText="Description"></app-label>
                        <app-read-only readonlyText="{{ courseDetail.description }}"></app-read-only>
                    </div>
                    <div class="col-3">
                        <div class="grid">
                            <div class="col">
                                <app-label labelText="eQMS Scope(s)"></app-label>
                                <div *ngFor="let eqmsScope of courseDetail.eQMSScopeDisplayNames">
                                    <app-read-only readonlyText="{{ eqmsScope }}" toolTipMessage="{{eqmsScope}}"></app-read-only>
                                </div>
                            </div>
                        </div>
                        <div class="grid">
                            <div class="col">
                                <app-label labelText="Validity Period"></app-label>
                                <app-read-only readonlyText="{{ courseDetail.validityPeriod }}"></app-read-only>
                            </div>
                        </div>
                    </div>
                </div>
            </p-fieldset>
            <p-fieldset legend = "{{courseDetailsHeader}}" [toggleable]="true">
                <div class="grid">
                    <div class="col">
                        <app-label labelText="Owner(s)"></app-label>
                        <div *ngFor="let owner of courseDetail.owners">
                            <app-read-only [ngClass]="{'inactive':owner.isActive===false || owner.isTerminated===true}"
                            readonlyText="{{owner.assignedUserName}}"  toolTipMessage="{{owner.assignedUserName}}"></app-read-only>
                        </div>
                    </div>
                    <div class="col">
                        <app-label labelText="Qualified Trainer(s)"></app-label>
                        <div *ngIf="areQualifiedTrainersPresent==false">
                            <app-read-only readonlyText="N/A"></app-read-only>
                        </div>
                        <div *ngIf="areQualifiedTrainersPresent == true">
                            <div *ngFor="let qualifiedTrainer of courseDetail.qualifiedTrainers">
                                <app-read-only [ngClass]="{'inactive':qualifiedTrainer.isActive===false || qualifiedTrainer.isTerminated === true}"
                                readonlyText="{{ qualifiedTrainer.assignedUserName }}" toolTipMessage="{{ qualifiedTrainer.assignedUserName }}">
                                </app-read-only>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <app-label labelText="Recommended Max # of Attendees"></app-label>
                        <app-read-only readonlyText="{{courseDetail.recommendedMaxAttendees}}"></app-read-only>
                    </div>
                    <div class="col">
                        <app-label labelText="Estimated Duration"></app-label>
                        <app-read-only readonlyText="{{courseDetail.estimatedDuration}}"></app-read-only>
                    </div>
                </div>
            </p-fieldset>
            <p-fieldset legend = "{{courseScoringHeader}}" [toggleable]="true">
                <div class="grid">
                    <div class="col">
                        <app-label labelText="Scoring Options"></app-label>
                        <app-read-only readonlyText="{{courseDetail.scoringOption}}"></app-read-only>
                    </div>
                    <div class="col">
                        <app-label labelText="Minimum Passing Score"></app-label>
                        <app-read-only readonlyText="{{courseDetail.minimumPassingScore}}"></app-read-only>
                    </div>
                    <div class="col">
                        <app-label labelText="Proficiency Quiz"></app-label>
                        <app-read-only readonlyText="{{courseDetail.proficiencyQuiz}}"></app-read-only>
                    </div>
                    <div class="col">
                    </div>
                </div>
            </p-fieldset> 
             <p-fieldset legend="{{ coursePrerequisitesHeader}}" [toggleable]="true">
                <div *ngFor="let prerequisite of courseDetail.prerequisites" class="mt-1">
                    <em class="pi pi-external-link blue-color cursor-pointer" (click)="openPrerequisites(prerequisite.number, prerequisite.version, prerequisite.prerequisiteType)"></em>
                    <span>
                      <a class="ml-3 underline blue-color cursor-pointer overflow-ellipse" (click)="openPrerequisites(prerequisite.number, prerequisite.version, prerequisite.prerequisiteType)">
                        {{ prerequisite.number }} {{ prerequisite.title }}
                      </a>
                    </span>
                  </div>
             </p-fieldset>    
          </p-tabPanel>
          <p-tabPanel header="Session" *ngIf="isInstuctorLedCourse">
            <app-sesssion-management
                *ngIf="isSessionTabActive"
                [courseInfoDetails]="courseDetail" 
                [minimumPassingScore]="courseMinimumPassingScore"
                [ScoringOption]="courseDetail.scoringOption"
                [ProficiencyQuiz]="courseDetail.proficiencyQuiz">
            </app-sesssion-management>
         </p-tabPanel>
          <p-tabPanel header="Training Material">
                <div class="grid">
                    <div class="col">
                        <app-label labelText="Instructions"></app-label>
                        <div class="pt-1 text-justify word-wrap">
                        <app-read-only readonlyText="{{ courseDetail.trainingMaterial?.instructions }}"></app-read-only>
                        </div>
                    </div>
                </div>
                <br/>
                <div class="grid">
                    <div class="col" *ngIf="courseDetail.trainingMaterial?.isURLVideo && courseDetail.trainingMaterial?.urlLink !== null && courseDetail.trainingMaterial?.urlLink !== undefined">
                        <div class="col-3"></div>
                        <iframe width="560" height="315" [src]="courseDetail.trainingMaterial?.urlLink | safe" frameborder="0" allowfullscreen></iframe>
                    </div>
                    <div class="col" *ngIf="!courseDetail.trainingMaterial?.isURLVideo && courseDetail.trainingMaterial?.urlLink !== null && courseDetail.trainingMaterial?.urlLink !== undefined">
                        <app-label labelText="URL Link"></app-label>
                        <div class="mt-1">
                            <em class="pi pi-external-link blue-color cursor-pointer" 
                            (click)="openLink(courseDetail.trainingMaterial!!.urlLink)">
                            <span>
                                <a style="font-family: bpt-font-family;" class="ml-3 underline blue-color cursor-pointer overflow-ellipse" (click)="openLink(courseDetail.trainingMaterial!!.urlLink)">
                                    {{LinkText}}
                                </a>
                            </span>
                            </em>
                        </div>
                    </div>
                </div>
                <br/>
                <p-fieldset legend = "Attachments" [toggleable]="true">

                    <div *ngFor="let attachment of courseDetail.trainingMaterial?.attachments" class="mt-1">
                        <em class="blue-color cursor-pointer" (click)="downloadAttachment(attachment.attachmentFileId, attachment.attachmentName)"

                          ><app-file-icon [fileType]="attachment.attachmentType"></app-file-icon
                        ></em>
                        <span class="ml-3">{{ attachment.attachmentName }}</span>
                      </div>
                </p-fieldset>
                <br/>
                <p-fieldset legend = "Related Documents" [toggleable]="true">
                    <div *ngFor="let document of courseDetail.trainingMaterial?.relatedDocuments; trackBy: trackByDocumentNumber" class="mt-1">
                        <em class="pi pi-external-link blue-color cursor-pointer" (click)="loadDocumentDetails(document.number, document.version)"></em>
                        <span>
                          <a class="ml-3 underline blue-color cursor-pointer overflow-ellipse" (click)="loadDocumentDetails(document.number, document.version)">
                            {{ document.number }} {{ document.title }}
                          </a>
                        </span>
                      </div>
                </p-fieldset>
          </p-tabPanel>
         <p-tabPanel header="Training" *ngIf="loadTrainingDetails">
            <app-course-training 
                *ngIf="isTrainingTabActive"
                [courseDetail]="courseDetail"
                [courseDetail]="courseDetail"
                [trainingItemGroups] = "trainingItemGroupsForCourse"
                (reloadTrainingData) = "reloadCourseDetails()">
                 </app-course-training>
        </p-tabPanel>
        </p-tabView>
    </div>
    </div>
</div>
<app-course-slider [isCourseSliderOpen]="isCourseSliderOpen"
    (isCourseSliderActive)="closeSlider($event)" [courseDetails]="courseDetail">
</app-course-slider>
<app-course-proficiency-quiz-slider
    *ngIf="isCourseProficiencyQuizSliderOpen"
    [courseNumber]="courseDetail.courseNumber"
    [minimumPassingScore]="courseDetail.minimumPassingScore"
    [isCourseProficiencyQuizSliderOpen]="isCourseProficiencyQuizSliderOpen"
    (isCourseProficiencyQuizSliderActive)="closeCourseProficiencyQuizSlider($event)"
>
</app-course-proficiency-quiz-slider>
<app-training-requirement-slider *ngIf="isCreateTrSliderOpen" 
    [isCreateTrSliderOpen]="isCreateTrSliderOpen"
    (isCreateTrSliderActive)="closeCreateTrainingRequirementSlider($event)"
    [trainingRequirement]="trainingRequirement"
    >
  </app-training-requirement-slider>

  <app-training-item-group-management
    *ngIf="isTrainingItemGroupManagementSliderOpen"
    [isTrainingItemGroupManagementSliderOpen]="isTrainingItemGroupManagementSliderOpen"
    (isTrainingItemGroupManagementActive)="closeTrainingItemGroupManagementSlider($event)"
    [defaultTrainingItemGroups] = "trainingItemGroupsForCourse"
    [trainingItemGroupsLookupRequest] = "trainingItemGroupsLookupRequest"
  ></app-training-item-group-management>
<ng-template #courseNotFound>
    <app-error [errorMessage]="courseErrorMessages()"></app-error>
    </ng-template>
